import React from "react";
import { Divider, Select } from "antd";
import "./CustomDropdown.scss";

type OptionItem = {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  desc?: string;
  disabled?: boolean;
};

interface ICustomDropdown {
  placeholder?: string;
  options?: OptionItem[];
  selectedValue?: any;
  showSearch?: boolean;
  mode?: string;
  disabled?: boolean;
  notFoundContent?: React.ReactNode;
  dropdownRender?: (menu: React.ReactNode) => React.ReactNode;
  renderOptions?: (option: any) => React.ReactNode;
  onChange?: (value: any) => void;
  label?: string;
  name?: string;
  className?: string;
  labelClassName?: string;
  onSearch?: (value: any) => void;
}

const CustomDropdown: React.FC<ICustomDropdown> = ({
  placeholder = "Select",
  options,
  selectedValue,
  showSearch,
  disabled,
  notFoundContent,
  dropdownRender,
  renderOptions,
  onChange,
  label,
  name,
  className,
  labelClassName,
  onSearch,
}) => {
  return (
    <div>
      {label && (
        <label className={`w-[100%] label text-[#6A6A6A] text-[14px] whitespace-nowrap ${labelClassName ?? ""}`} htmlFor={name}>
          {label}
        </label>
      )}
      <Select
        className={className}
        style={{ width: "100%" }}
        placeholder={placeholder}
        value={selectedValue}
        defaultValue={selectedValue}
        disabled={disabled}
        onChange={onChange}
        
        notFoundContent={notFoundContent}
        showSearch={showSearch}
        onSearch={onSearch}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: "8px 0" }} />
            {dropdownRender?.(menu)}
          </>
        )}
        options={options}
        optionRender={(option) => renderOptions?.(option) || option.label}
        filterOption={(input, option) => {
          if (option && option.value) {
            return (
              String(option.label).toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
              String(option.value).toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
              String(option.desc).toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }

          return false;
        }}
      />
    </div>
  );
};

export default CustomDropdown;
